// extracted by mini-css-extract-plugin
export default {"descTitle":"resetPasswordSentPage_descTitle__bT6FE","descBody":"resetPasswordSentPage_descBody__bzOzQ","firstParagraph":"resetPasswordSentPage_firstParagraph__C29ag"};